module.exports = __webpack_public_path__ + "static/img/khalaspay-achievement-bg.8504fea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/khalaspay-achievement-bg.png
// module id = euXc
// module chunks = 9